import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import BASE_URL from "components/BaseUrl/apiConfig";
import MapSearch from "../Admin/MapSearch";

function ShowLocationMap() {
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [locations, setLocations] = useState(null);
  const [centerCords, setCenterCords] = useState({
    lat: 20.5937,
    lng: 78.9629,
  });
  const [currentLocation, setCurrentLocation] = useState(null);

  // Fetch user's current location
  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const userLocation = {
            lat: latitude,
            lng: longitude,
          };
          setCurrentLocation(userLocation);
          setCenterCords(userLocation); // Center map on user's location
        },
        (error) => {
          console.error("Error fetching current location:", error.message);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }

  const UserID =
    JSON.parse(localStorage.getItem("userData") || "{}").userId || "";

  async function LocationsByUserID(UserID) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/Locations/LocationsByUserID?UserID=${UserID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const locations = await response.json();
      return locations;
    } catch (error) {
      console.error("Error fetching locations:", error.message);
    }
  }

  useEffect(() => {
    getLocation();
    LocationsByUserID(UserID)
      .then((locations) => {
        const modifiedLocations = locations.map((location) => ({
          id: location.id,
          title: location.title,
          fullAddress: location.fullAddress,
          LatLng: {
            lat: Number(location.latitude),
            lng: Number(location.longitude),
          },
          addressDescription: location.addressDescription,
        }));
        setLocations(modifiedLocations);
      })
      .catch((error) => {
        console.log("Failed to fetch locations:", error.message);
      });
  }, []);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: null, // "YOUR_GOOGLE_MAPS_API_KEY"
  });

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading Maps...</div>;

  return (
    <>
      <Navbar />
      <div className="min-h-content-minvh mx-3">
        <h1 className="text-2xl px-3 py-2">My Locations</h1>
        <div className="px-3">
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "520px" }}
            center={centerCords}
            zoom={15}
            options={{
              disableDefaultUI: false,
              scrollwheel: true,
              gestureHandling: "greedy",
            }}
          >
            {/* Show user's current location */}
            {currentLocation && (
              <Marker
                position={currentLocation}
                zIndex={999}
                // label={{
                //   text: "You are here",
                //   color: "blue",
                //   fontSize: "12px",
                // }}
                icon={{
                  url: "https://img.icons8.com/?size=35&id=3391&format=png&color=000000",
                  size: new window.google.maps.Size(35, 35), // Adjust size as needed
                  origin: new window.google.maps.Point(0, 0),
                  anchor: new window.google.maps.Point(16, 32), // Align marker icon
                }}
                title="You are here"
              />
            )}

            {/* Show other locations */}
            {locations &&
              locations.map((marker, index) => (
                <Marker
                  key={index}
                  position={marker.LatLng}
                  // label={{
                  //   text: marker.title,
                  //   color: "black",
                  //   fontSize: "12px",
                  // }}
                  title={marker.title}
                  onClick={() => setSelectedMarker(marker)} // Set marker as selected on click
                />
              ))}

            {selectedMarker && (
              <InfoWindow
                position={selectedMarker.LatLng}
                onCloseClick={() => setSelectedMarker(null)} // Close the InfoWindow
              >
                <div>
                  <h4>{selectedMarker.title}</h4>
                  <p>
                    <strong>Full Address:</strong> {selectedMarker.fullAddress}
                  </p>
                  <p>
                    <strong>Description:</strong>{" "}
                    {selectedMarker.addressDescription}
                  </p>
                </div>
              </InfoWindow>
            )}
          </GoogleMap>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ShowLocationMap;
